"use client"

import React, {useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Button, Divider, Text, Textarea, TextInput} from "@mantine/core";
import {useForm, zodResolver} from "@mantine/form";
import {IOpinionDTO} from "@/form/opinion";
import {z} from "zod";
import {opinionSubmit} from "@/service/opinion";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize } = useGlobalStateStore();
    const [tab, setTab] = useState<number>(1);
    const [opinionDone, setOpinionDone] = useState<boolean>(false);
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    const nonEmptyString = z.string({message: "欄位必填"}).nullable().refine(value => value !== null && value.trim() !== '', {
        message: '欄位必填',
    });

    const schema = z.object({
        name: nonEmptyString,
        mail: z.string().email({message: "EMAIL 格式錯誤"}),
        title: nonEmptyString,
        content: nonEmptyString,
        tel: nonEmptyString,
    });

    const form = useForm<IOpinionDTO>({
        mode: 'controlled',
        validate: zodResolver(schema),
        initialValues: {
            name: '',
            mail: '',
            title: '',
            content: '',
            tel: '',
        }
    });

    const handleFormSubmit = () => {
        opinionSubmit(form.values).then(() => {
            setOpinionDone(true)
        });
    }

    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                <Bread name="關於科政中心 - 輿情回應"/>
                <div className="w-[1250px] mx-auto mb-[100px]">
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold">
                        輿情回應
                    </div>


                    <div className="mt-[40px]">
                        <div
                            className="text-[#8d7f4c] text-[46px] font-bold">歡迎留言給我們
                        </div>
                    </div>


                    <Divider mt={30} my={35}/>

                    <div className="flex gap-[50px]">
                        <div className="w-1/2">
                            <div className="text-[20px] leading-10 text-justify">
                                本專區旨在對社會大眾關切或輿論報導與本中心業務有關之議題， 及時適切的作分析說明或回應，俾增進各界了解。
                                若您有與本中心業務相關的問題， 也歡迎透過本中心意見信箱 <a className="text-blue-700 underline px-2" href="mailto:pr.stpi@niar.org.tw">pr.stpi@niar.org.tw</a>反應，
                                或填寫左方聯絡資料及留言，我們將盡快為您處理。
                            </div>
                        </div>

                        <div className="w-1/2">
                            {/*<div className="text-[20px] text-red-600 pb-10">*/}
                            {/*    欄位加入星號※必填*/}
                            {/*</div>*/}

                            {
                                !opinionDone && (
                                    <form className="flex flex-col gap-[30px]" onSubmit={form.onSubmit(handleFormSubmit)}>

                                        <TextInput label={"姓名"} size={"lg"} withAsterisk
                                                   maxLength={50}
                                                   key={form.key('name')}
                                                   {...form.getInputProps('name')}/>
                                        <TextInput label={"電話"} size={"lg"} withAsterisk
                                                   maxLength={50}
                                                   key={form.key('tel')}
                                                   {...form.getInputProps('tel')}/>
                                        <TextInput label={"電子郵件"} size={"lg"} withAsterisk
                                                   maxLength={200}
                                                   key={form.key('mail')}
                                                   {...form.getInputProps('mail')}/>
                                        <TextInput label={"標題"} size={"lg"} withAsterisk
                                                   description={"請在50字內"}
                                                   maxLength={50}
                                                   key={form.key('title')}
                                                   {...form.getInputProps('title')}/>
                                        <Textarea label={"內容"} size={"lg"} withAsterisk
                                                  autosize
                                                  minRows={3}
                                                  maxLength={2000}
                                                  key={form.key('content')}
                                                  {...form.getInputProps('content')}/>
                                        <Button type="submit">送出</Button>
                                    </form>
                                )
                            }

                            {
                                opinionDone && (
                                    <Text c={"dark"} size="lg">資料已送出，謝謝您的回應。</Text>
                                )
                            }


                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
        ;
}
